import React from 'react';
import { IconButton, Box, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { Bell, Activity, Briefcase, Calendar } from 'react-feather';
import makeStyles from '@mui/styles/makeStyles';

const sidebarFooterStyles = makeStyles((theme) => {
    return {
        appSidebarFooterWrapper: (props) => {
            const { sidebarToggle } = props;
            return {
                background: 'rgba(0,0,0,.03)',
                margin: theme.themeVars.spacer,
                borderRadius: theme.themeVars.borderRadiusSm,
                transition: theme.themeVars.transitionBase,
                ...(sidebarToggle
                    ? {
                          visibility: 'hidden',
                          opacity: '0'
                      }
                    : {})
            };
        },
        appSidebarFooter: {
            listStyle: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: theme.themeVars.sidebarFooterHeight,
            padding: `0 ${theme.themeVars.spacer}`,
            margin: '0'
        }
    };
});

const SidebarFooter = (props) => {
    const { sidebarToggle } = props;
    const classes = sidebarFooterStyles({ sidebarToggle });

    return (
        <Box className={classes.appSidebarFooterWrapper}>
            <ul className={classes.appSidebarFooter}>
                <li>
                    <Tooltip arrow title="Projects Application">
                        <IconButton href="/ApplicationsProjects" size="large">
                            <Activity />
                        </IconButton>
                    </Tooltip>
                </li>
                <li>
                    <Tooltip arrow title="Helpdesk Dashboard">
                        <IconButton href="/DashboardHelpdesk" size="large">
                            <Bell />
                        </IconButton>
                    </Tooltip>
                </li>
                <li>
                    <Tooltip arrow title="Calendar Application">
                        <IconButton href="/ApplicationsCalendar" size="large">
                            <Calendar />
                        </IconButton>
                    </Tooltip>
                </li>
                <li>
                    <Tooltip arrow title="Buttons">
                        <IconButton href="/Buttons" size="large">
                            <Briefcase />
                        </IconButton>
                    </Tooltip>
                </li>
            </ul>
        </Box>
    );
};
SidebarFooter.defaultProps = {
    sidebarToggle: false
};
SidebarFooter.propTypes = {
    sidebarToggle: PropTypes.bool
};

export default SidebarFooter;
